import Parse from '@/parse'
const Message = Parse.Object.extend('Message')

export default {
  initForm ({ state, commit }) {
    commit('setContent', state.message.get('content'))
    commit('setUser', state.message.get('user'))
  },

  resetForm ({ commit }, user) {
    commit('setContent', '')
    commit('setUser', user)
  },

  retrieveMessages ({ commit }) {
    let query = new Parse.Query(Message)
    query.descending('createdAt')
    query.find().then((results) => {
      commit('setMessages', results)
    }).catch((error) => {
      console.log(error)
    })
  },

  async getMessage({ commit }, id) {
    let query = new Parse.Query(Message)
    try {
      let object = await query.get(id)
      commit('setMessage', object)
    } catch (error) {
      console.log(error)
    }
  },

  async saveMessage({ state, dispatch }, action) {
    let message = state.message
    if (action === 'new') {
      message = new Message()
      message.set('date', new Date())
    }

    message.set('content', state.content)
    let query = new Parse.Query(Parse.User)
    const user = await query.get(state.user)
    message.set('user', state.user)
    message.set('username', user.get('username'))

    try {
      await message.save()
      let snackBarMessage = 'メッセージを更新しました。'
      if (action === 'new') {
        snackBarMessage = 'メッセージを作成しました。'
      }
      return snackBarMessage
    } catch (error) {
      dispatch(
        'snackBar/addMessage',
        error,
        { root: true }
      )
    }
  },

  deleteMessage({ state, commit }) {
    state.message.destroy().then(() => {
      commit(
        'snackBar/addMessage',
        'メッセージを削除しました。',
        { root: true }
      )
    })
  }
}
